<template>
    <div class="principal">
        <NavBar :usarAberto="false" :usarHistorico="false" :usarVoltar="true" :usarDeslogar="false" :usarGerenciar="false"
            :usarRelatorio="false" :usarRelatorioEstrela="true" :usarRelatorioEstrelaAtend="true" :usarFiltros="true"
            :usarFiltroSetor="true" :usarFiltroTpChamado="true" :usarFiltroPosicao="false" :usarFiltroDatas="true"
            @filtrar="filtrar()" :usarTrocaVisualizacao="true" :card="false" :tabela="true" :grafico="true"
            :visualizacaoPadrao="'Tabela'" :nomeTela="'Tempo Médio por Setor/Tipo de Chamado'"
            :formatarDataInicioMes="formatarDataInicioMes" />

        <div class="mainDiv">
            <table class="table table-striped" v-show="this.tabela === 'Tabela'">
                <thead>
                    <tr>
                        <th class="col-sm-7 col-md-7">Setor</th>
                        <th class="col-sm-1 col-md-1">Chamado</th>
                        <th class="col-sm-1 col-md-1">Data</th>
                        <th class="col-sm-1 col-md-1">Confirmados</th>
                        <th class="col-sm-1 col-md-1">Tempo Médio</th>
                        <!-- <th class="col-sm-1 col-md-1">Tempo Médio</th> -->
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(d, index) in this.dadosRelatorioTabela" :key="index">
                        <td class="col-sm-7 col-md-7"> {{ d.setorDescricao }} </td>
                        <td class="col-sm-1 col-md-1"> {{ d.tipoChamadoDescricao }} </td>
                        <td class="col-sm-1 col-md-1"> {{ retornaDataFormatada(d.data) }} </td>
                        <td class="col-sm-1 col-md-1"> {{ d.qtdeConfirmados }} </td>
                        <td class="col-sm-1 col-md-1"> {{ converterHora(d.tempoMedio) || retornaPosicao(d.posicao) }}
                        </td>
                        <!-- <td class="col-sm-1 col-md-1"> {{ retornaPosicao(d['posicao']) }} </td> -->
                    </tr>
                </tbody>
            </table>

        </div>
        <div class="displayFlex flex-column" v-show="this.tabela === 'Grafico'">
            <button @click="alterarVisualizacao()" class="btn" :disabled="this.btnDesabilitado">Alterar
                Gráfico</button>
            <canvas id="graficoRelatorioTempoMedioPizza" class="graficoRelatorio"
                v-show="this.visualizacaoDeGraficos === false"></canvas>
            <canvas id="graficoRelatorioTempoMedioBarra" class="graficoRelatorio"
                v-show="this.visualizacaoDeGraficos === true"></canvas>
        </div>
    </div>

    <ModalEditar :mostrar="existeErro" :tamanhoModal="30">
        <template v-slot:header>
            {{ this.titulo }}
        </template>
        <template v-slot:corpo>
            {{ this.textoErro }}
        </template>
        <template v-slot:rodape>
            <button @click="desativarModal()" class="btn btn-primary">Entendi</button>
        </template>
    </ModalEditar>

    <ModalEditar :mostrar="this.mostrarModalBarra" :modalLargo="true" :tamanhoModal="60">
        <template v-slot:header>
            <h2>Tempo Médio</h2>
        </template>
        <template v-slot:corpo>
            <table class="table table-striped table-bordered">
                <thead>
                    <tr>
                        <th>Setor</th>
                        <th>Tempo médio</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(d, index) in this.dadoModal" :key="index">
                        <td>{{ d.setorDescricao }}</td>
                        <td>{{ converterHora(d.tempoMedio) }}</td>
                    </tr>
                </tbody>
            </table>
        </template>
        <template v-slot:rodape>
            <button class="btn btn-secondary" @click="fecharModal()">Fechar</button>
        </template>
    </ModalEditar>

    <ModalEditar :mostrar="this.mostrarModalPizza" :modalLargo="true" :tamanhoModal="60">
        <template v-slot:header>
            <h2>Tempo Médio</h2>
        </template>
        <template v-slot:corpo>
            <table class="table table-striped table-bordered">
                <thead>
                    <tr>
                        <th>Chamado</th>
                        <th>Tempo médio</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(d, index) in this.dadoModal" :key="index">
                        <td>{{ d.chamadoDescricao }}</td>
                        <td>{{ converterHora(d.tempoMedio) }}</td>
                    </tr>
                </tbody>
            </table>
        </template>
        <template v-slot:rodape>
            <button class="btn btn-secondary" @click="fecharModal()">Fechar</button>
        </template>
    </ModalEditar>
</template>

<script>
import api from '@/api/api';
import store from "@/store/store";
import { BarController, BarElement, LineController, LinearScale, } from 'chart.js';
import { Chart, CategoryScale, Title, PieController, ArcElement, DoughnutController } from 'chart.js';
import NavBar from '@/components/NavBar.vue';
import moment from 'moment';
import ModalEditar from '@/components/ModalEditar.vue';

export default {
    name: "relatoriO",

    props: ['formatarDataInicioMes'],

    mounted() {
        Chart.register(LinearScale, LineController, CategoryScale, BarElement, BarController, Title);
        Chart.register(CategoryScale, Title, PieController, ArcElement, DoughnutController);
        this.construirTabela(0, 0, this.formatarDataInicioMes(new Date()), new Date());

        setTimeout(() => {
            this.tipoChamado.forEach((t) => {
                this.lstTpChamado.push(t.descricao);
            });
        }, 1500);
    },

    data() {
        return {
            dados: [],
            dadosHora: [],
            dadoModal: [],
            dadosRelatorioTabela: [],
            lstSetor: [],
            lstTpChamado: [],
            lstTempoMedio: [],
            textoErro: String(),
            existeErro: Boolean(),
            titulo: String(),
            grafico: null,
            graficoTempoMedioSetor: null,
            visualizacaoDeGraficos: true,
            mostrarModalBarra: false,
            mostrarModalPizza: false,
            tabela: "Tabela",
            valorFiltroTPChamado: Number(),
            valorFiltroSetor: Number(),
            dataInicial: new Date(),
            dataFinal: new Date(),
            btnDesabilitado: Boolean()
        };
    },

    methods: {
        async construirGraficoPizza() {
            const graficoRelatorioTempoMedioPizza = document.getElementById("graficoRelatorioTempoMedioPizza").getContext("2d");
            if (this.grafico) {
                this.grafico.destroy();
            }

            let setoresDesc = [];
            this.dadosRelatorioTabela.forEach((d) => {
                setoresDesc.push(d.setorDescricao);
            });

            let lstTempo = [(this.dadosHora[0]?.hora / this.dadosHora[0]?.qtdeConf).toFixed(0), (this.dadosHora[1]?.hora / this.dadosHora[1]?.qtdeConf).toFixed(0), (this.dadosHora[2]?.hora / this.dadosHora[2]?.qtdeConf).toFixed(0)];
            let lstCores = [this.dadosHora[0]?.cor, this.dadosHora[1]?.cor, this.dadosHora[2]?.cor];

            setoresDesc = [...new Set(setoresDesc)];

            let conversaoParaHora = this.converterHora;

            const hoverValue = {
                id: 'hoverValue',
                afterDatasetsDraw(chart) {
                    const { ctx, data, options } = chart;
                    chart.getActiveElements().forEach((active) => {
                        // ${data.labels[active.index]} 
                        let value = Number(data.datasets[active.datasetIndex].data[active.index]).toFixed(0);
                        const fontSize = options.hoverRadius;
                        value = conversaoParaHora(value);
                        ctx.save();
                        ctx.textAlign = 'center';
                        ctx.font = `bold ${fontSize}px sans-serif`;
                        ctx.lineDashOffset = 10;
                        ctx.fillText(value, active.element.x, 160);
                        ctx.restore();
                    });
                }
            };

            this.grafico = new Chart(graficoRelatorioTempoMedioPizza, {
                type: "pie",
                data: {
                    labels: this.lstTpChamado,
                    datasets: [
                        {
                            label: lstTempo, //
                            data: lstTempo, // Valor do tempo médio
                            backgroundColor: lstCores,
                            hoverOffset: 4,
                            hoverBorderWidth: 2
                        },
                    ],
                },
                options: {
                    hoverRadius: 20,
                    plugins: {
                        title: {
                            display: true,
                            text: 'Tempo Médio por Tipo de Chamado',
                            padding: {
                                top: 10,
                                bottom: 30
                            },
                            font: {
                                size: 20
                            }
                        }
                    },
                    onClick: async (e) => {
                        let aux = [];
                        this.lstTpChamado.forEach((l) => {
                            this.dadoModal.push({
                                'chamadoDescricao': l,
                                'tempoMedio': 0
                            });
                            aux[l] = 0;
                        });
                        let tempo = e.chart.data.datasets[0].data;

                        tempo.forEach((t, index) => {
                            this.dadoModal[index].tempoMedio = t;
                        });

                        this.mostrarModalPizza = true;
                    },
                    animation: {
                        duration: 1000
                    }
                },
                plugins: [hoverValue]
            });
        },

        async construirGraficoBarra() {
            const graficoRelatorioTempoMedioBarra = document.getElementById("graficoRelatorioTempoMedioBarra").getContext("2d");
            if (this.graficoTempoMedioSetor) {
                this.graficoTempoMedioSetor.destroy();
            }

            let lstTempo = new Object();
            let aux = new Object();
            let setoresDesc = [];

            this.dadosHora.forEach((d) => {
                if (lstTempo[d.descricao] == undefined) {
                    lstTempo[d.descricao] = 0;
                }
                if (aux[d.descricao] == undefined) {
                    aux[d.descricao] = 0;
                }
                setoresDesc.push(d.descricao);
                aux[d.descricao]++;
            });

            setoresDesc = [...new Set(setoresDesc)];

            setoresDesc.forEach((d, index) => {
                lstTempo[d] = Number((this.dadosHora[index].hora /= this.dadosHora[index].qtdeConf).toFixed(0));
            });

            //não tem como acessar o this para pegar a função dentro do hover value
            let conversaoParaHora = this.converterHora;
            //mas da certo se jogar a função dentro da variavel e usar

            const hoverValue = {
                id: 'hoverValue',
                afterDatasetsDraw(chart) {
                    const { ctx, data, options } = chart;
                    chart.getActiveElements().forEach((active) => {
                        let value = data.datasets[active.datasetIndex].data[data.labels[active.index]].toFixed(0);// + "s";
                        const fontSize = options.hoverRadius;
                        value = conversaoParaHora(value);
                        ctx.save();
                        ctx.textAlign = 'center';
                        ctx.font = `bold ${fontSize}px sans-serif`;
                        ctx.lineDashOffset = 10;
                        ctx.fillText(value, active.element.x, active.element.y);
                        ctx.restore();
                    });
                },
            };

            if (this.dadosRelatorioTabela.length > 0) {
                this.graficoTempoMedioSetor = new Chart(graficoRelatorioTempoMedioBarra, {
                    type: "bar",
                    data: {
                        labels: setoresDesc,
                        datasets: [
                            {
                                label: lstTempo, //
                                data: lstTempo, // Valor do tempo médio
                                backgroundColor: ['rgba(255, 99, 132, 0.2)'],
                                borderColor: ['rgb(255, 99, 132)'],
                                maxBarThickness: 35,
                                fill: false,
                                barPercentage: 0.5,
                                hoverOffset: 4
                            },
                        ],
                    },
                    options: {
                        hoverRadius: 20,
                        plugins: {
                            title: {
                                display: true,
                                text: 'Tempo Médio por Setor',
                                padding: {
                                    top: 10,
                                    bottom: 30
                                },
                                font: {
                                    size: 20
                                }
                            },
                        },
                        scales: {
                            y: {
                                ticks: {
                                    callback: (value) => {
                                        let aux = value, i = 0, filtrado = false;
                                        if (aux >= 60) {
                                            while (aux >= 60) {
                                                aux -= 60;
                                                i++;
                                            }
                                            if (i != 0) {
                                                return this.converterHora(60 * i);
                                            }
                                            filtrado = true;
                                        }
                                        if (aux >= 5 && filtrado == false) {
                                            while (aux >= 5) {
                                                aux -= 5;
                                                i++;
                                            }
                                            if (i != 0) {
                                                return this.converterHora(5 * i);
                                            }
                                        }
                                    }
                                },
                            }
                        },
                        onClick: async (e) => {
                            let setores = e.chart.data.labels;

                            setores.forEach((l) => {
                                this.dadoModal.push({
                                    'setorDescricao': l,
                                    'tempoMedio': 0
                                });
                            });

                            this.dadoModal.forEach((m) => {
                                m.tempoMedio = lstTempo[m.setorDescricao];
                            });

                            this.mostrarModalBarra = true;
                        },
                        animation: {
                            duration: 1000
                        }
                    },
                    plugins: [hoverValue]
                });
                Chart.defaults.font.size = 18;
            }

        },

        montarObjetoTabela(pObjAux) {
            let aux = {};
            aux['data'] = pObjAux[0];
            aux['idSetor'] = pObjAux[1];
            aux['setorDescricao'] = pObjAux[2];
            aux['idTipoChamado'] = pObjAux[3];
            aux['tipoChamadoDescricao'] = pObjAux[4];
            aux['qtdeConfirmados'] = pObjAux[5];
            aux['tempoMedio'] = pObjAux[6];
            aux['cor'] = pObjAux[7];
            aux['posicao'] = pObjAux[8];
            this.dadosRelatorioTabela.push(aux);
        },

        async construirTabela(pValorFiltroSetor, pValorFiltroTPChamado, pDataInicial, pDataFinal) {
            let sql = "SELECT * FROM P_CHAMADO_MEDIA P";
            if (this.retornaData(pDataInicial) > this.retornaData(pDataFinal)) {
                this.titulo = "Aviso";
                this.textoErro = "A Data Inicial não pode ser maior que a Data Final";
                this.existeErro = true;
            } else {
                let auxDataInicial = moment(pDataInicial).format("DD.MM.YYYY");
                let auxDataFinal = moment(pDataFinal).format("DD.MM.YYYY");
                sql += ` WHERE P.OUT_DATA BETWEEN '${auxDataInicial}' AND '${auxDataFinal}'
                        ORDER BY P.OUT_DATA DESC`;
                await api.listarSql(sql)
                    .then(resp => {
                        this.visualizacaoDeGraficos = true;
                        this.dadosRelatorioTabela = [];
                        resp.forEach((r) => {
                            if (isNaN(pValorFiltroSetor)) {
                                if (pValorFiltroSetor == "AD" && pValorFiltroTPChamado == 0) {
                                    (r[8] === "AD") ? this.montarObjetoTabela(r) : "";
                                    return;
                                }
                                if (pValorFiltroSetor == "AD" && pValorFiltroTPChamado > 0) {
                                    (pValorFiltroTPChamado === r[3] && r[8] === "AD") ? this.montarObjetoTabela(r) : "";
                                    return;
                                }
                            } else {
                                if (pValorFiltroSetor == 0 && pValorFiltroTPChamado == 0) {
                                    this.montarObjetoTabela(r);
                                    return;
                                }
                                if (pValorFiltroSetor > 0 && pValorFiltroTPChamado > 0) {
                                    (pValorFiltroSetor === r[1] && pValorFiltroTPChamado === r[3]) ? this.montarObjetoTabela(r) : "";
                                    return;
                                }
                                if (pValorFiltroSetor > 0 && pValorFiltroTPChamado == 0) {
                                    (pValorFiltroSetor === r[1]) ? this.montarObjetoTabela(r) : "";
                                    return;
                                }
                                if (pValorFiltroSetor == 0 && pValorFiltroTPChamado > 0) {
                                    (pValorFiltroTPChamado === r[3]) ? this.montarObjetoTabela(r) : "";
                                    return;
                                }
                            }
                        });
                    });
            }
        },

        async montarObjetoGrafico(pValorFiltroSetor, pValorFiltroTPChamado, pDataInicial, pDataFinal) {
            let sql = "";
            let auxDataInicial = moment(pDataInicial).format("DD.MM.YYYY");
            let auxDataFinal = moment(pDataFinal).format("DD.MM.YYYY");

            sql += `SELECT
                    `;

            if (this.visualizacaoDeGraficos) {
                sql += `SUM (C.HRFINALIZACAO - C.HORA), S.ID, count(*), S.DESCRICAO, S.DESCRICAO
                    `;
            } else {
                sql += `SUM (C.HRFINALIZACAO - C.HORA), T.ID, count(*), T.DESCRICAO, T.COR
                    `;
            }

            sql += `FROM CHAMADO C
                    JOIN TIPO_CHAMADO T ON T.ID = C.ID_TIPO_CHAMADO
                    JOIN LEITO L ON L.ID = C.ID_LEITO
                    JOIN QUARTO Q ON Q.ID = L.ID_QUARTO
                    JOIN SETOR S ON S.ID = Q.ID_SETOR
                    WHERE
                    C.POSICAO = 'FE'
                    `;

            if (pValorFiltroTPChamado != 0) {
                sql += `AND T.ID = ${pValorFiltroTPChamado}
                    `;
            }

            if (pValorFiltroSetor != 0) {
                sql += `AND S.ID = ${pValorFiltroSetor}
                    `;
            }

            sql += `AND C.DATA between '${auxDataInicial}' and '${auxDataFinal}' GROUP BY 2,4,5`;

            await api.listarSql(sql)
                .then(resp => {
                    this.dadosHora = [];
                    resp.forEach((r) => {
                        let aux = {};
                        aux['hora'] = r[0];
                        aux['id'] = r[1];
                        aux['qtdeConf'] = r[2];
                        aux['descricao'] = r[3];
                        aux['cor'] = r[4];
                        this.dadosHora.push(aux);
                    });
                });
        },

        alterarVisualizacao() {
            this.visualizacaoDeGraficos = !this.visualizacaoDeGraficos;
            this.alterarGrafico();
            this.bloquearBotao();
        },

        bloquearBotao() {
            this.btnDesabilitado = true;
            setTimeout(() => {
                this.btnDesabilitado = false;
            }, 1000);
        },

        async alterarGrafico() {
            await this.montarObjetoGrafico(this.valorFiltroSetor, this.valorFiltroTPChamado, this.dataInicial, this.dataFinal);
            if (this.visualizacaoDeGraficos) {
                this.construirGraficoBarra();
            } else {
                this.construirGraficoPizza();
            }
        },

        retornaDataFormatada(pData) {
            return moment(pData).format("DD/MM/YYYY");
        },

        retornaData(pData) {
            return new Date(pData);
        },

        converterHora(pSegundos) {
            let horaFinal = "", auxDia = 0, auxHora = 0, auxMinuto = 0, auxSegundo = pSegundos;

            while (auxSegundo >= 60) {
                auxMinuto++;
                auxSegundo = auxSegundo - 60;
            }

            while (auxMinuto >= 60) {
                auxHora++;
                auxMinuto -= 60;
            }

            while (auxHora >= 24) {
                auxDia++;
                auxHora -= 24;
            }

            if (auxDia > 0) {
                horaFinal += auxDia + "d ";
            }

            if (auxHora > 0) {
                horaFinal += auxHora + "h ";
            }

            if (auxMinuto > 0) {
                horaFinal += auxMinuto + "m ";
            }

            if (Number(auxSegundo).toFixed(0) > 0) {
                horaFinal += Number(auxSegundo).toFixed(0) + "s ";
            }

            //horaFinal = auxHora + auxHora + "h " + auxMinuto + "m " + auxSegundo.toFixed(0) + "s ";
            return horaFinal;
        },

        async filtrar(aux, pValorFiltroSetor, pValorFiltroTPChamado, pValorFiltroPosicao, pDataInicial, pDataFinal, pVisualizacao) {
            this.tabela = pVisualizacao;
            this.valorFiltroTPChamado = pValorFiltroTPChamado;
            this.valorFiltroSetor = pValorFiltroSetor;
            this.dataInicial = pDataInicial;
            this.dataFinal = pDataFinal;
            this.dadosHora = [];
            if (pVisualizacao === "Grafico") {
                this.bloquearBotao();
                await this.alterarGrafico();
            } else {
                await this.construirTabela(pValorFiltroSetor, pValorFiltroTPChamado, pDataInicial, pDataFinal);
            }
        },

        deslogar() {
            sessionStorage.removeItem("TokenReguaPainel");
            this.$router.back();
        },

        desativarModal() {
            this.existeErro = false;
        },

        fecharModal() {
            this.mostrarModalBarra = false;
            this.mostrarModalPizza = false;
            this.dadoModal = [];
        },

        retornaPosicao(pParam) {
            let nomeCompleto;
            switch (pParam) {
                case "AB":
                    nomeCompleto = "Aberto";
                    break;
                case "AD":
                    nomeCompleto = "Administrativo";
                    break;
                case "FE":
                    nomeCompleto = "Fechado";
                    break;
                case "CA":
                    nomeCompleto = "Cancelado";
                    break;
            }
            return nomeCompleto;
        }

    },

    computed: {
        setores() {
            return store.state.setores;
        },
        config() {
            return store.state.config;
        },
        tipoChamado() {
            return store.state.tipoChamado;
        },
    },

    components: {
        NavBar,
        ModalEditar
    }
};
</script>

<style scoped>
canvas {
    display: block;
}

.displayFlex {
    display: grid;
}
</style>